module.exports = __webpack_public_path__ + "static/media/karly-jones-K3p8QlzBf7M-unsplash.202eee81.jpg";